import React from 'react';
import { styleOptions } from '../styleOptions';

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

const VerandaDimensionsStep = ({
  width,
  height,
  glazed,
  onWidthChange,
  onHeightChange,
  onGlazedChange,
  errors,
  product,
  style
}) => {
  // Get the product image based on selected product and style
  const getProductImage = () => {
    if (product) {
      const productStyles = styleOptions[product];

      if (productStyles && productStyles.length > 0) {
        // First, try to find the exact style match
        if (style) {
          const selectedStyle = productStyles.find(s => s.id === style);

          if (selectedStyle && selectedStyle.image) {
            return selectedStyle.image;
          }
        }

        // If no exact match, use the first available style image for this product
        const firstStyle = productStyles[0];
        if (firstStyle && firstStyle.image) {
          return firstStyle.image;
        }
      }
    }

    // Fallback to placeholder
    return 'https://placehold.co/600x516?text=Veranda';
  };

  const productImage = getProductImage();
  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Enter Dimensions
      </h2>

      {/* Two Column Layout */}
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 px-4 md:grid-cols-2">
        {/* Left Column - Image */}
        <div className="relative h-[516px] overflow-hidden rounded-lg">
          <img
            src={productImage}
            alt="Veranda"
            className="h-full w-full object-cover"
          />
        </div>

        {/* Right Column - Form */}
        <div className="flex flex-col justify-center rounded-lg bg-gray-100 p-12">
          <h3 className="mb-6 text-center text-[24px] font-bold text-black">
            Enter Your Dimensions
          </h3>

          {/* Width Input */}
          <div className="mb-6">
            <label className="mb-2 block text-[15px] text-[#4c4c4c]">
              Width (metres)*
            </label>
            <input
              type="number"
              step="0.1"
              min="0"
              value={width}
              onChange={(e) => onWidthChange(e.target.value)}
              placeholder="e.g., 4.5"
              className="w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-[#252525] placeholder:text-[#9ca2ae] focus:border-[#ED6B64] focus:outline-none"
            />
            {errors?.width && (
              <p className="mt-2 text-sm text-red-500">{errors.width}</p>
            )}
          </div>

          {/* Projection Input */}
          <div className="mb-6">
            <label className="mb-2 block text-[15px] text-[#4c4c4c]">
              Projection (metres)*
            </label>
            <input
              type="number"
              step="0.1"
              min="0"
              value={height}
              onChange={(e) => onHeightChange(e.target.value)}
              placeholder="e.g., 3.0"
              className="w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-[#252525] placeholder:text-[#9ca2ae] focus:border-[#ED6B64] focus:outline-none"
            />
            {errors?.height && (
              <p className="mt-2 text-sm text-red-500">{errors.height}</p>
            )}
          </div>

          {/* Glazed/Unglazed Toggle */}
          <div className="mb-6">
            <p className="mx-auto mb-4 text-center text-[15px] font-medium text-[#4c4c4c]">
              Glazed or Unglazed?
            </p>
            <div className="flex justify-center gap-4">
              <label className="flex cursor-pointer items-center gap-2">
                <input
                  type="radio"
                  name="glazed"
                  checked={glazed === true}
                  onChange={() => onGlazedChange(true)}
                  className="h-5 w-5 border-2 border-[#d9d9d9] text-[#ED6B64] focus:ring-[#ED6B64]"
                />
                <span className="text-[15px] text-[#4c4c4c]">Glazed</span>
              </label>
              <label className="flex cursor-pointer items-center gap-2">
                <input
                  type="radio"
                  name="glazed"
                  checked={glazed === false}
                  onChange={() => onGlazedChange(false)}
                  className="h-5 w-5 border-2 border-[#d9d9d9] text-[#ED6B64] focus:ring-[#ED6B64]"
                />
                <span className="text-[15px] text-[#4c4c4c]">Unglazed</span>
              </label>
            </div>
          </div>

          <p className="mx-auto text-center text-xs text-[#4c4c4c]">
            These dimensions are approximate and can be adjusted later
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerandaDimensionsStep;
